import type { ChangeEvent, ReactNode } from 'react';

import { Icon } from '#/components/Icon/Icon';
import type { IconName } from '#/components/Icon/IconName';
import { Pill } from '#/components/Pill/Pill';
import { SearchRefinementDropdownHolder } from '#/modules/search/components/Refinement/Dropdown/SearchRefinementDropdown.styled';
import type { SearchRefinementType } from '#/modules/search/constants/refinements/searchRefinementTypes';

import { useSearchFilterToggleButton } from './useSearchFilterToggleButton';

type Props = {
  facetType: SearchRefinementType;
  initialValue: boolean;
  icon?: IconName;
  label: ReactNode;
};

export function SearchFilterToggleButton({
  facetType,
  icon,
  initialValue,
  label,
}: Props) {
  const { toggleButtonStatus, holderRef, toggleButton } =
    useSearchFilterToggleButton(facetType);

  return (
    <SearchRefinementDropdownHolder
      data-qa-id={`search-facet-dropdown-${facetType}`}
      ref={holderRef}
      data-facet-state={toggleButtonStatus}
    >
      <label>
        <input
          defaultChecked={initialValue}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            void toggleButton(e.target.checked);
          }}
          name={facetType}
          type="checkbox"
          style={{ display: 'none' }}
        />
        <Pill
          qaId="search-filter-dropdown-heading"
          size={{ xs: 'small', md: 'medium' }}
          prefix={icon ? <Icon size={18} name={icon} /> : undefined}
          suffix={<Icon name="simple-check" size={16} />}
        >
          {label}
        </Pill>
      </label>
    </SearchRefinementDropdownHolder>
  );
}
